export default "__VITE_ASSET__DYJ_acoO__"